import React from "react";
import { useLocation } from "react-router-dom";
import useAuthBootstrap from "../hooks/useAuthBootstrap";
import useDomainBranding from "../hooks/useDomainBranding";
import { LandingRoutes, SpecialPublicIslands, CreateAccountIsland, EmailVerificationIsland } from "./publicRoutes";
import ProtectedRoutes from "./protectedRoutes";
import GetUserCompanies from "components/usercompanies/GetUserCompanies";

const isPublicIslandPath = (p) => p.includes("EmanifestPreview") || p.includes("form_view_renderer") || p.includes("service_executor_workflow") || p.includes("reset-password");

const isLandingPath = (p) =>
	p === "/" ||
	p === "/landing" ||
	p === "/EmanifestPreview/:id" ||
	p === "/contact" ||
	p === "/aboutus" ||
	p === "/faq" ||
	p === "/manuals" ||
	p === "/emanifest" ||
	p === "/facilities" ||
	p === "/privacypolicy" ||
	p === "/services";

export default function FalconRoutes() {
	const { pathname } = useLocation();

	const { branding, brandingReady } = useDomainBranding();

	const { ready, authenticated, hasCompany, companyReady, loginComponent, hostHasLanding, kickingOffKc } = useAuthBootstrap(pathname, branding, brandingReady);

	if (pathname.includes("create-account")) return <CreateAccountIsland />;
	if (pathname.includes("email-verification")) return <EmailVerificationIsland />;
	if (isPublicIslandPath(pathname)) return <SpecialPublicIslands />;

	if (!ready || !brandingReady) return null;

	if (!authenticated) {
		if (pathname === "/" && loginComponent === "LoginPage" && kickingOffKc) {
			return null;
		}
		if (isLandingPath(pathname)) {
			return <LandingRoutes loginComponent={loginComponent} isAuthenticated={false} />;
		}
		return null;
	}

	if (!companyReady) return null;
	if (!hasCompany) return <GetUserCompanies />;

	return <ProtectedRoutes hostHasLanding={hostHasLanding} loginComponent={loginComponent} />;
}
